import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { Query } from 'react-apollo'

import { SELF_QUERY } from '../../../queries'

import { Switch, Key, Cogwheel, Logout } from '../../Icons'
import { IconNavDropDown, IconNavDropDownItem, IconNavDropDownIconContainer } from '../../../styles/defaults-header'
import { Intro, IntroTitle, IntroSubtitle } from './styles'
import helpers from '../../../helpers'

class UserMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleSwitchBranch() {
    this.props.onSwitchBranch()
  }

  render() {
    const { permissions } = this.props
    
    return (
      <IconNavDropDown>
        <Intro>
          <Query query={SELF_QUERY}>
            {({ loading, error, data }) => {
              let username = ''
              const { self } = data
              if (self) {
                self.insertion = helpers.findInsertion(self.insertion)
                username = self.firstName + ' ' + (self.insertion !== null ? self.insertion + ' ' : '') + self.lastName
              }
              return (
                <Fragment>
                  <IntroTitle>
                    Welkom,<br />
                    {username}
                  </IntroTitle>
                  <IntroSubtitle>{this.props.branchName}</IntroSubtitle>
                </Fragment>
              )
            }}
          </Query>
        </Intro>

        {permissions.multipleBranches ? (
          <div onClick={this.handleSwitchBranch.bind(this)}>
            <IconNavDropDownItem>
              <IconNavDropDownIconContainer>
                <Switch size="" />
              </IconNavDropDownIconContainer>
              Wissel van filiaal
            </IconNavDropDownItem>
          </div>
        ) : null}

        {permissions.viewUsers ? (
          <Link to="/medewerkers" onClick={this.handleClick.bind(this)}>
            <IconNavDropDownItem>
              <IconNavDropDownIconContainer>
                <Key size="" />
              </IconNavDropDownIconContainer>
              Medewerkers
            </IconNavDropDownItem>
          </Link>
        ) : null}

        {permissions.editProfile ? (
          <Link to="/instellingen" onClick={this.handleClick.bind(this)}>
            <IconNavDropDownItem>
              <IconNavDropDownIconContainer>
                <Cogwheel size="" />
              </IconNavDropDownIconContainer>
              Instellingen
            </IconNavDropDownItem>
          </Link>
        ) : null}

        <Link to="/" onClick={this.props.handleLogout}>
          <IconNavDropDownItem>
            <IconNavDropDownIconContainer>
              <Logout size="" />
            </IconNavDropDownIconContainer>
            Uitloggen
          </IconNavDropDownItem>
        </Link>
      </IconNavDropDown>
    )
  }
}

export default withRouter(UserMenu)



// WEBPACK FOOTER //
// ./src/components/Header/UserMenu/index.js